import { Box, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';

interface TemporalAlertProps {
    message: string;
    title: string;
    onClose: () => void;
}

export const TemporalAlert = ({ message, title, onClose }: TemporalAlertProps) => {
    const theme = useTheme();
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        if (countdown === 0) {
            onClose();
            return undefined;
        }
        const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown, onClose]);

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                width: '100%',
                borderRadius: '0.5rem',
                border: `${theme.palette.primary[300]} 1px solid`,
                boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)'
            }}
        >
            <Box sx={{ backgroundColor: theme.palette.primary[300], px: '0.5rem', pt: '0.5rem', pb: '0.25rem' }}>
                <Typography sx={{ fontSize: '1.25rem', fontWeight: 500, color: '#54595E', mb: '0.5rem' }}>{title}</Typography>
                <Box sx={{ width: '100%', backgroundColor: '#FF9800', borderRadius: '0.5rem' }}>
                    <Typography sx={{ fontSize: '0.875rem', fontWeight: 400, color: theme.palette.background.paper, p: '0.5rem' }}>
                        {message}
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ width: '100%', p: '0.5rem' }}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 400, textAlign: 'center' }}>
                    This message will disappear in ...{' '}
                    <span style={{ color: theme.palette.common.black, fontWeight: 700 }}>{countdown}</span> seconds.
                </Typography>
            </Box>
        </Box>
    );
};
